import Vue from 'vue'
import { makeQueryStringDync, makeQueryFormDataDyn, errorServeiceHandler } from '../helper'
const state = {
}
const getters = {
}
const mutations = {
}
const actions = {
  getAlertMessage: (context, dataObj) => {
    return new Promise( (resolve, reject) => {
    if (dataObj.alerttype == 'ALERT') {
      let alertMessage = JSON.parse(localStorage.getItem('alertMessage'))
      if (alertMessage) {
        if (Object.keys(alertMessage).length) {
          resolve(alertMessage)
          return
        }
      }
    } else if (dataObj.alerttype == 'OFFERS') {
      let alertOffer = JSON.parse(localStorage.getItem('alertOffer'))
      if (alertOffer) {
        if (Object.keys(alertOffer).length) {
          resolve(alertOffer)
          return
        }
      }
    } else if (dataObj.alerttype == 'NXT_UDAAN') {
      let alertNXTUddan = JSON.parse(localStorage.getItem('alertNXTUddan'))
      if (alertNXTUddan) {
        if (Object.keys(alertNXTUddan).length) {
          resolve(alertNXTUddan)
          return
        }
      }
    } else if (dataObj.alerttype == 'SUPER_ACHIEVERS_LCO') {
      let alertSAL = JSON.parse(localStorage.getItem('alertSAL'))
      if (alertSAL) {
        if (Object.keys(alertSAL).length) {
          resolve(alertSAL)
          return
        }
      }
    }
    console.log(typeof(dataObj.alerttype))
    let queryStr = ''
    queryStr = makeQueryStringDync(dataObj)
      fetch(context.getters.baseUrl + '/lco/v1/alertmessage.php' + queryStr, {
        method: 'GET'
        })
        .then(errorServeiceHandler)
        .then((response) => {
            return response.json()
          }).then((data) => {
            // if (dataObj.alerttype == 'ALERT') {
            //   localStorage.setItem("alertMessage",JSON.stringify(data))
            // } else if (dataObj.alerttype == 'OFFERS') {
            //   localStorage.setItem("alertOffer",JSON.stringify(data))
            // } else if (dataObj.alerttype == 'NXT_UDAAN') {
            //   localStorage.setItem("alertNXTUddan",JSON.stringify(data))
            // } else if (dataObj.alerttype == 'SUPER_ACHIEVERS_LCO') {
            //   localStorage.setItem("alertSAL",JSON.stringify(data))
            // }
            resolve(data)
          }).catch((error) => {
            reject(error);
          });
        });
  },
  getAlertData: (context) => {
    return new Promise( (resolve, reject) => {
      fetch(context.getters.baseUrl + '/lco/v1/alertmessage.php', {
        method: 'GET'
        })
        .then(errorServeiceHandler)
        .then((response) => {
            return response.json()
          }).then((data) => {
            resolve(data)
          }).catch((error) => {
            reject(error);
          });
        });
  },
  headendLocation: (context) => {
    return new Promise( (resolve, reject) => {
      fetch(context.getters.baseUrl + '/lco/v1/headend/locations', {
        method: 'GET'
        })
        .then(errorServeiceHandler)
        .then((response) => {
            return response.json()
          }).then((data) => {
            resolve(data)
          }).catch((error) => {
            reject(error);
          });
        });
  },
  headendLocationByName: (context, dataObj) => {
    return new Promise( (resolve, reject) => {
    let queryStr = ''
    queryStr = makeQueryStringDync(dataObj)
      fetch(context.getters.baseUrl + '/lco/v1/headend' + queryStr, {
        method: 'GET'
        })
        .then(errorServeiceHandler)
        .then((response) => {
            return response.json()
          }).then((data) => {
            resolve(data)
          }).catch((error) => {
            reject(error);
          });
        });
  },
  unreadClickedData: (context, payload) => {
    console.log(payload)
    return new Promise((resolve, reject) => {
        localStorage.removeItem("alertMessage")
        localStorage.removeItem("alertOffer")
        localStorage.removeItem("alertNXTUddan")
        localStorage.removeItem("alertSAL")
        let data = makeQueryFormDataDyn(payload);
        console.log("API CALL")
       fetch(context.getters.baseUrl + '/lco/v1/alertmessage', {
        method: 'POST',
        body: data
       })
       .then(errorServeiceHandler)
       .then((response) => {
          return response.json()    
       }).then((data) => {
            resolve(data)
        }).catch((error) => {
            reject(error)
        });
    });
  },
  quizQuestions: (context) => {
    return new Promise( (resolve, reject) => {
      fetch(context.getters.baseUrl + '/lco/v1/quiz/questions', {
        method: 'GET'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        resolve(data)
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve(
            [{"ans1":"Tele Regulatory Associations of India ","ans2":"Telecom Regulatory Authority of India","ans3":"Telecom Regulatory Association of India","key":"A","question":"What is the full form of TRAI?"},{"ans1":"ONE Email","ans2":"ONE Broadband ","ans3":"ONE Network ","key":"B","question":"What is the Internet Service Provider<b> ONE<\/b>OTT <b>INTERTAINMENT LIMITED<\/b> also called? "},{"ans1":"<b>IN<\/b>Digital  ","ans2":"<b>NXT<\/b>DIGITAL Limited","ans3":"In Cable ","key":"C","question":"What is IMCL called post de-merger? "},{"ans1":"My <b>NXT<\/b>","ans2":"My <b>NXT<\/b>DIGITAL","ans3":"<b>NXT<\/b>DIGITAL SELFCARE","key":"D","question":"What is the name of the mobile app for <b>NXT<\/b>DIGITAL-HITS platform? "},{"ans1":"ICICI ","ans2":"HDFC","ans3":"STATE BANK OF INDIA ","key":"E","question":"Which bank is now integrated with the <b>NXT<\/b>DIGITAL-HITS Portal for direct payment through NEFT\/RTGS\/IMPS? "}])
          return
        }
        reject(error);
      });
    });
  },
  submitAnswerDetails: (context, payload) => {
    return new Promise((resolve, reject) => {
       fetch(context.getters.baseUrl + '/lco/v1/quiz', {
        method: 'POST',
        body: payload
       })
       .then(errorServeiceHandler)
       .then((response) => {
          return response.json()    
       }).then((data) => {
            resolve(data)
        }).catch((error) => {
            reject(error)
        });
    });
  },
};

export default {
    state, getters, mutations, actions
};



// WEBPACK FOOTER //
// ./src/store/modules/alertModule.js